import React from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import userLogout from "../../utils/userLogout";
import useAutoLogout from "../../utils/useAutoLogout";
import LiveChat from "./LiveChat";
import useClassroomVideoData from "../../utils/use-classroomVideoData";
import CustomVideoPlayer from "../VideoPlayer/CustomVideoPlayer";
import Rating from "../Classroom/Rating";
import VideoDescription from "../Classroom/VideoDescription";

const LiveClassroom = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = () => userLogout(navigate, dispatch);
  useAutoLogout(handleLogout);
  const videoData = useClassroomVideoData(id);
  const data = videoData?.details?.lecture?.[0];

  return (
   <div className="flex md:flex-row flex-col lg:m-[1.5rem] m-[1rem] md:gap-2 gap-4 lg:mb-[2rem] mb-[12rem] md:pb-0 pb-[6rem] overflow-hidden">
      <div className="lg:w-screen w-auto">
        <div className="flex flex-col">
          <div>{data && <CustomVideoPlayer data={data} />}</div>
          <div>
            <VideoDescription data={data} />
          </div>
          {/* <div>
            <Rating data = {data} id = {id}/>
          </div> */}
        </div>
      </div>
      <div className="md:static fixed bottom-0 left-0 right-0 z-50 md:w-auto w-full bg-white h-[52vh]">
        <LiveChat id={id} />
      </div>
    </div>
  );
};

export default LiveClassroom;
